import { useIntl } from "react-intl";

import { Editions, ProductKeys } from "@atlassiansox/asc-stargate";

import { useCrossFlowFrontendTouchpoint } from "@/components/cross-flow/touchpoint";
import { useLocalizedHref } from "@/libraries/web-framework";
import { LogoV2 } from "@/libraries/wpl/foundations/src";
import { ProductPageSubNav } from "@/patterns/global-nav/src";

const JpdLogo = () => (
    <LogoV2 brand="jiraproductdiscovery" type="logo" appearance="brand" />
);

const JiraProductDiscoveryNavV2 = () => {
    const intl = useIntl();
    const signupLink = useLocalizedHref(
        "/try/cloud/signup?bundle=jira-product-discovery"
    );
    const { openCrossFlow } = useCrossFlowFrontendTouchpoint({
        productKey: ProductKeys.JIRA_PRODUCT_DISCOVERY,
        edition: Editions.FREE,
        redirectUrl: signupLink
    });
    const links = [
        {
            globalLinksKey: "pricing",
            linkText: intl.formatMessage({
                // this id should be renamed, but for Team'24 hotfix we need to keep existing mapping
                id: "jiraproductdiscovery.navbar.features",
                defaultMessage: "Pricing"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: useLocalizedHref("/software/jira/product-discovery/pricing")
        },
        {
            globalLinksKey: "productGuide",
            linkText: intl.formatMessage({
                id: "jiraproductdiscovery.navbar.product-guide",
                defaultMessage: "Guide"
            }),
            hasSubnav: false,
            productKey: "jiraProductDiscovery",
            href: useLocalizedHref(
                "/software/jira/product-discovery/guides/getting-started/introduction"
            )
        }
    ];

    // TODO: this duplicates the value from the v1 product nav
    // this was to use an accurate existing translation for a Team'24 hot fix
    const ctaText = intl.formatMessage({
        id: "productNavBar.get-it-free-button",
        defaultMessage: "Get it free"
    });

    return (
        <ProductPageSubNav
            productLogoUrl={useLocalizedHref(
                "/software/jira/product-discovery"
            )}
            productLogo={<JpdLogo />}
            productLogoAriaLabel={intl.formatMessage({
                id: "wacJiraProductDiscoveryNavigation.logo-label",
                defaultMessage: "Jira Product Discovery logo"
            })}
            mobileCtaText={ctaText}
            mobileCtaUrl={signupLink}
            mobileCtaOnClick={openCrossFlow}
            mobileLogo={<JpdLogo />}
            navigationTrynowCtaText={ctaText}
            navigationTrynowCtaUrl={signupLink}
            navigationTrynowCtaOnClick={openCrossFlow}
            productPageNavLinks={links}
            mobileLinksSections={[
                {
                    key: "mobile-jira-product-discovery",
                    mobileLinksProps: links
                }
            ]}
        />
    );
};

JiraProductDiscoveryNavV2.displayName = "JiraProductDiscoveryNavV2";

export default JiraProductDiscoveryNavV2;
